import {store} from "../../store"
import apiClientToken from "../../plugins/axiosToken";
import Controller from "../Controller"

export default class Remedy_incidencias{
    
    CargaArchivoReportesREMEDY(context,params){   
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFReportesREMEDY.svc/RestService/CargaArchivoReportesREMEDY",params)        
            .then(function(response){                
                if(response.data.ok)
                    resolve(controller.getData(context,response));
                else
                    reject(response.data);
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    GetIncidenciasPendientes(context){   
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFReportesREMEDY.svc/RestService/GetIncidenciasPendientes")        
            .then(function(response){                
                if(response.data.ok)
                    resolve(controller.getData(context,response));
                else
                    reject(response.data);
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    GetOrdenesPendientes(context){   
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFReportesREMEDY.svc/RestService/GetOrdenesPendientes")        
            .then(function(response){                
                if(response.data.ok)
                    resolve(controller.getData(context,response));
                else
                    reject(response.data);
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }
    
}